<template>
	<div>
		<goal-status-report mine-only :goal-id="id" />
	</div>
</template>

<script>
	// Reports
	import GoalStatusReport from '@/components/reports/GoalStatusReport';

	export default {
		props: {
			id: {
				type: String,
				required: true
			}
		},
		components: {
			GoalStatusReport
		},
		data() {
			return {};
		},
		created() {
			this.$store.dispatch('setPageTitle', 'My Goals');
		}
	};
</script>

<style></style>
